<template>
  <div>
    <div v-if="rangeText" class="an-status">
      <span>{{ rangeText }}</span>
    </div>

    <div v-for="(text, i) in warnings" :key="'w' + i" class="tf-alert tf-alert--warn">
      <i class="fa fa-exclamation-triangle tf-alert__icon"></i>
      <div class="tf-alert__body">
        <div class="tf-alert__title">{{ text }}</div>
      </div>
    </div>

    <section v-for="block in blocks" :key="block.id" class="tf-card">
      <div class="tf-card__head">
        <span class="tf-card__icon"><i class="fa" :class="icon(block.kind)"></i></span>
        <div class="tf-card__titles">
          <h3 class="tf-card__title">{{ block.title }}</h3>
          <p v-if="block.hint" class="tf-card__sub">{{ block.hint }}</p>
        </div>
      </div>
      <div class="tf-card__body">
        <ViewKpi v-if="block.kind === 'kpi'" :metrics="block.kpi || []"/>
        <ViewTimeseries v-else-if="block.kind === 'timeseries' && block.series" :series="block.series" :is-dark="isDark"/>
        <ViewFunnel v-else-if="block.kind === 'funnel' && block.funnel" :funnel="block.funnel"/>
        <ViewTable v-else-if="block.kind === 'table' && block.table" :table="block.table"/>
        <!-- сервис новее админки: блок нового вида не ломает остальные -->
        <div v-else class="an-empty">
          <i class="fa fa-wrench"></i>
          <span>Этот блок админка пока не умеет показывать</span>
        </div>
      </div>
    </section>

    <div v-if="!blocks.length" class="tf-card">
      <div class="an-empty">
        <i class="fa fa-inbox"></i>
        <span>В отчёте пока пусто</span>
      </div>
    </div>
  </div>
</template>

<script>
import ViewKpi from "./ViewKpi.vue";
import ViewTimeseries from "./ViewTimeseries.vue";
import ViewFunnel from "./ViewFunnel.vue";
import ViewTable from "./ViewTable.vue";
import {formatRange} from "@/common/viewFormat";

const ICONS = {
  kpi: 'fa-tachometer',
  timeseries: 'fa-line-chart',
  funnel: 'fa-filter',
  table: 'fa-table',
}

/**
 * Отчёт сторонней системы в общем виде сервиса аналитики:
 * {range, blocks: [{kind, id, title, hint, kpi|series|funnel|table}], warnings}.
 */
export default {
  name: "ViewBoard",
  components: {ViewKpi, ViewTimeseries, ViewFunnel, ViewTable},
  props: {
    data: {type: Object, required: true},
    isDark: {type: Boolean, default: false},
  },
  computed: {
    blocks() {
      return this.data.blocks || []
    },
    warnings() {
      return this.data.warnings || []
    },
    rangeText() {
      const r = this.data.range
      if (!r || !r.from) return ''
      const cur = formatRange(r.from, r.to)
      if (!r.prevFrom) return `Период: ${cur}`
      return `Период: ${cur} · сравнение с ${formatRange(r.prevFrom, r.prevTo)}`
    },
  },
  methods: {
    icon(kind) {
      return ICONS[kind] || 'fa-square-o'
    },
  },
}
</script>
